export type NameValidationError =
  | 'empty'
  | 'too_short'
  | 'too_long'
  | 'has_digits'
  | 'has_invalid_chars'
  | 'too_many_words';

const MIN_LENGTH = 2;
const MAX_LENGTH = 40;
const MAX_WORDS = 3;

const DIGIT_RE = /\d/u;
const ALLOWED_RE = /^[\p{L}\p{M}\s\-’'`.]+$/u;

export function validateName(raw: string): NameValidationError | null {
  const name = raw.trim();
  if (name.length === 0) return 'empty';
  if (name.length < MIN_LENGTH) return 'too_short';
  if (name.length > MAX_LENGTH) return 'too_long';
  if (DIGIT_RE.test(name)) return 'has_digits';
  if (!ALLOWED_RE.test(name)) return 'has_invalid_chars';
  const words = name.split(/\s+/).filter(Boolean);
  if (words.length > MAX_WORDS) return 'too_many_words';
  return null;
}

export function nameErrorKey(error: NameValidationError): string {
  switch (error) {
    case 'empty':
      return 'form.error.name';
    case 'too_short':
      return 'form.error.name_short';
    case 'too_long':
      return 'form.error.name_long';
    case 'has_digits':
      return 'form.error.name_digits';
    case 'has_invalid_chars':
      return 'form.error.name_invalid';
    case 'too_many_words':
      return 'form.error.name_words';
  }
}
